/**
 * CROEV Quiz v1 engine — Lumerval
 * Drives sections/croev-quiz-v1.liquid: one-at-a-time step navigation, answer capture,
 * dynamic personalization ({problem_areas}, {first_win}, {date_30}, {date_60}),
 * a progress bar that doubles as the header's bottom border, loading/gauge animation,
 * an always-visible bottom CTA bar, and the final reveal of the offer page beneath.
 *
 * Forward-only (no Back). Config-driven via data-* the section/snippets print — no hardcoded copy.
 */
(function () {
  'use strict';

  var QUESTION_TYPES = { question_text: 1, question_input: 1 };
  var PROGRESS_TYPES = { question_text: 1, question_input: 1, info_step: 1 };

  function init(root) {
    if (!root || root.dataset.cqReady === '1') return;
    root.dataset.cqReady = '1';

    var steps = [].slice.call(root.querySelectorAll('.croev-quiz__step'));
    if (!steps.length) return;

    var progressFill = root.querySelector('[data-cq-progress-fill]');
    var progressPct = root.querySelector('[data-cq-progress-pct]');
    var footerbar = root.querySelector('[data-cq-footerbar]');
    var answers = {};
    var current = -1;

    /* ---- progress ---- */
    var totalQuestions = steps.filter(function (s) { return QUESTION_TYPES[s.dataset.stepType]; }).length;
    function progressFor(i) {
      var type = steps[i].dataset.stepType;
      if (!PROGRESS_TYPES[type]) return 100; // loading/summary = full bar
      var seen = 0;
      for (var k = 0; k <= i; k++) { if (QUESTION_TYPES[steps[k].dataset.stepType]) seen++; }
      return Math.round((seen / (totalQuestions + 1)) * 100);
    }
    function setProgress(i) {
      var pct = progressFor(i);
      if (progressFill) progressFill.style.width = pct + '%';
      if (progressPct) {
        var c = Math.min(100, Math.max(0, pct));
        // anchor the pill's edge near the track ends so it never overflows the viewport
        progressPct.style.left = c + '%';
        progressPct.style.transform = 'translateX(' + (c <= 7 ? '0%' : (c >= 93 ? '-100%' : '-50%')) + ')';
        progressPct.textContent = pct + '%';
        progressPct.removeAttribute('hidden');
      }
    }

    /* ---- personalization (token -> highlighted chip; guarantees spacing) ---- */
    function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
    function chip(text) { return '<strong class="cq-hl">' + esc(text) + '</strong>'; }
    function fmtList(items) {
      items = items.filter(Boolean);
      if (!items.length) return '';
      if (items.length === 1) return items[0];
      if (items.length === 2) return items[0] + ' and ' + items[1];
      return items.slice(0, -1).join(', ') + ', and ' + items[items.length - 1];
    }
    function problemAreas() {
      var a = answers['problem_areas'];
      return (a && a.shorts.length) ? fmtList(a.shorts) : 'the signs you noticed';
    }
    function firstWin() {
      var a = answers['first_win'];
      if (!a || !a.shorts.length) return 'feeling like yourself again';
      var s = a.shorts[0];
      return s.charAt(0).toLowerCase() + s.slice(1);
    }
    function offsetDate(days) {
      var d = new Date(); d.setDate(d.getDate() + days);
      try { return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }); }
      catch (e) { return (d.getMonth() + 1) + '/' + d.getDate(); }
    }
    function substitute(tpl) {
      return tpl
        .replace(/\{problem_areas\}/g, chip(problemAreas()))
        .replace(/\{first_win\}/g, chip(firstWin()))
        .replace(/\{date_30\}/g, chip(offsetDate(30)))
        .replace(/\{date_60\}/g, chip(offsetDate(60)));
    }
    function renderPersonalized(step) {
      [].forEach.call(step.querySelectorAll('[data-cq-personalize]'), function (el) {
        if (el.__cqTpl == null) el.__cqTpl = el.innerHTML; // cache raw template on a JS prop (no DOM round-trip)
        el.innerHTML = substitute(el.__cqTpl);
      });
    }

    /* ---- bottom CTA bar: move the active step's CTA into a fixed footer so it's always visible ---- */
    function placeCta(step) {
      if (!footerbar) return;
      var held = footerbar.querySelector('.croev-quiz__cta-wrap');
      if (held && held.__home) { held.__home.appendChild(held); }
      var cta = step.querySelector('.croev-quiz__cta-wrap');
      if (cta) {
        if (!cta.__home) cta.__home = cta.parentNode;
        footerbar.appendChild(cta);
        footerbar.removeAttribute('hidden');
      } else {
        footerbar.setAttribute('hidden', '');
      }
    }

    /* ---- navigation (forward only) ---- */
    function show(i) {
      if (i < 0 || i >= steps.length) return;
      if (current >= 0) steps[current].classList.remove('is-active');
      current = i;
      var step = steps[i];
      renderPersonalized(step);
      step.classList.add('is-active');
      setProgress(i);
      placeCta(step);
      try { window.scrollTo(0, 0); } catch (e) {}
      var type = step.dataset.stepType;
      if (type === 'loading_step') runLoading(step);
      if (type === 'summary_profile') runGauge(step);
    }
    function advance() { if (current < steps.length - 1) show(current + 1); }

    /* ---- per-step wiring ---- */
    function storeAnswer(step) {
      var qid = step.dataset.questionId;
      if (!qid) return;
      var picked = [].slice.call(step.querySelectorAll('.croev-quiz__option.is-selected'));
      answers[qid] = {
        values: picked.map(function (o) { return o.dataset.value; }),
        labels: picked.map(function (o) { return (o.querySelector('.croev-quiz__option-label') || o).textContent.trim(); }),
        shorts: picked.map(function (o) { return o.dataset.short || (o.querySelector('.croev-quiz__option-label') || o).textContent.trim(); })
      };
    }
    steps.forEach(function (step) {
      var type = step.dataset.stepType;

      if (type === 'question_text') {
        var multi = step.dataset.selection === 'multi';
        var options = [].slice.call(step.querySelectorAll('.croev-quiz__option'));
        var cont = step.querySelector('[data-cq-continue]');
        options.forEach(function (opt) {
          opt.addEventListener('click', function () {
            if (multi) {
              opt.classList.toggle('is-selected');
              opt.setAttribute('aria-checked', opt.classList.contains('is-selected') ? 'true' : 'false');
              if (cont) cont.disabled = !step.querySelector('.croev-quiz__option.is-selected');
            } else {
              options.forEach(function (o) { o.classList.remove('is-selected'); o.setAttribute('aria-checked', 'false'); });
              opt.classList.add('is-selected');
              opt.setAttribute('aria-checked', 'true');
              storeAnswer(step);
              if (step.dataset.autoAdvance === 'true') setTimeout(advance, 240);
              else if (cont) cont.disabled = false;
            }
          });
        });
        if (cont) cont.addEventListener('click', function () { if (!cont.disabled) { storeAnswer(step); advance(); } });
      }

      else if (type === 'question_input') {
        var input = step.querySelector('[data-cq-email]');
        var cont2 = step.querySelector('[data-cq-continue]');
        var err = step.querySelector('[data-cq-error]');
        var ok = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); };
        var submit = function () {
          var v = (input.value || '').trim();
          if (!ok(v)) { input.classList.add('is-error'); if (err) err.classList.add('is-visible'); input.focus(); return; }
          answers[step.dataset.questionId || 'email'] = { values: [v], labels: [v], shorts: [v] };
          try { localStorage.setItem('lumerval_quiz_email', v); } catch (e) {}
          advance();
        };
        if (input) {
          input.addEventListener('input', function () { input.classList.remove('is-error'); if (err) err.classList.remove('is-visible'); });
          input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
        }
        if (cont2) cont2.addEventListener('click', submit);
      }

      else if (type === 'info_step' || type === 'summary_profile') {
        var n = step.querySelector('[data-cq-continue]');
        if (n) n.addEventListener('click', advance);
      }

      else if (type === 'summary_results') {
        var r = step.querySelector('[data-cq-reveal]');
        if (r) r.addEventListener('click', function () {
          if (r.classList.contains('is-loading')) return;
          r.classList.add('is-loading');
          r.setAttribute('aria-busy', 'true');
          setTimeout(reveal, 1000); // brief "preparing your offer" beat
        });
      }
    });

    /* ---- loading animation ---- */
    function runLoading(step) {
      var items = [].slice.call(step.querySelectorAll('.croev-quiz__check'));
      items.forEach(function (it) { it.classList.remove('is-done'); });
      var dur = parseInt(step.dataset.duration, 10) || 4000;
      var per = items.length ? Math.max(450, Math.floor((dur * 0.78) / items.length)) : 0;
      items.forEach(function (it, n) { setTimeout(function () { it.classList.add('is-done'); }, per * (n + 1)); });
      var token = (step.dataset.cqToken = String((parseInt(step.dataset.cqToken, 10) || 0) + 1));
      setTimeout(function () { if (steps[current] === step && step.dataset.cqToken === token) advance(); }, dur);
    }

    /* ---- profile gauge ---- */
    function runGauge(step) {
      var arc = step.querySelector('[data-cq-gauge-arc]');
      var pctEl = step.querySelector('[data-cq-gauge-pct]');
      var target = Math.max(0, Math.min(100, parseInt(step.dataset.gaugePct, 10) || 0));
      if (arc) {
        var r = parseFloat(arc.getAttribute('r')) || 90;
        var C = 2 * Math.PI * r;
        arc.style.strokeDasharray = C;
        arc.style.strokeDashoffset = C;
        void arc.getBoundingClientRect();
        requestAnimationFrame(function () { arc.style.strokeDashoffset = C * (1 - target / 100); });
      }
      if (pctEl) {
        var start = null, dur = 1300;
        var tick = function (ts) {
          if (start === null) start = ts;
          var p = Math.min(1, (ts - start) / dur);
          pctEl.textContent = Math.round(p * target) + '%';
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    }

    /* ---- reveal the offer page beneath the funnel ---- */
    function reveal() {
      document.body.classList.add('quiz-revealed');
      [].forEach.call(document.querySelectorAll('.croev-quiz-hidden'), function (el) { el.classList.remove('croev-quiz-hidden'); });
      var prev = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, 0);
      setTimeout(function () { window.scrollTo(0, 0); document.documentElement.style.scrollBehavior = prev; }, 60);
    }

    root._cqAnswers = answers;
    show(0);
  }

  function boot() { [].forEach.call(document.querySelectorAll('.croev-quiz-v1'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
